var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLyo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7695,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_300_501)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7753 17.1111L17.8806 11.8656L17.0202 10.4424C16.8481 10.2083 16.7139 10 16.2609 10H11.2752C11.0094 10 10.6753 10.22 10.7943 10.4424L14.7753 17.1111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7454 10.4346C26.8603 10.2162 26.5351 10 26.2808 10H21.4582C21.0131 10 20.8811 10.2024 20.7246 10.4346L16.2419 18.0966C16.1554 18.2197 16.1072 18.363 16.1025 18.5105V25.5631C16.1032 25.6788 16.1523 25.7896 16.2393 25.8714C16.3263 25.9532 16.4442 25.9994 16.5672 26H21.0009C21.1239 25.9994 21.2417 25.9532 21.3287 25.8714C21.4157 25.7896 21.4649 25.6788 21.4655 25.5631V19.4556L26.7454 10.4346Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_501",
    x1: 36.7695,
    y1: -0.00000107288,
    x2: 0.769528,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4380EC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyo);
export default __webpack_public_path__ + "static/media/LYO.197ac28c85c9615caebc659b299cb48e.svg";
export { ForwardRef as ReactComponent };